export default __webpack_public_path__ + "static/media/location_green.9918c1ea.svg";